// extracted by mini-css-extract-plugin
export default {"wrap":"SearchInput_wrap__ZZUQA","icon":"SearchInput_icon__iQv9t","input":"SearchInput_input__1kihN","clear":"SearchInput_clear__WEOzX"};